import { BaseContentFul } from './base-contentful.interface';

export interface AboutUsContent {
  yourWealths?: BaseContentFul[];
  wealthMaximisers?: BaseContentFul[];
}
